export function newExtraObject() {
  this.extraTitle = null,
  this.extraDescription = null,
  this.extraTitleImageURL = null,
  this.extrapricingType = null,
  this.extraVatPrecentage = null,
  this.extraPrice = null
}